import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Privilege from '../../entities/privilege';
import Role from '../../entities/role';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeletePrivilege(): boolean {
return true;
}
export function collectPrivilegeDeleteImpact(privilege: Privilege, context: DeleteImpactContext): void {
const key = 'privilege:' + privilege.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const rolePrivilegesImpact = workingRows<Role>('role', findAll<Role>('roles')).filter(roleRef => roleRef.privileges?.includes(privilege.id));
rolePrivilegesImpact.forEach(roleRef => addDeleteImpact(context, 'role:' + roleRef.id, 'roles'));}
export function deleteImpactPrivilege(privilege: Privilege): DeleteImpact {
const context = deleteImpactContext();
collectPrivilegeDeleteImpact(privilege, context);
return deleteImpactCounts(context);
}
export function deletePrivilege(privilege: Privilege, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeletePrivilege()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectPrivilegeDeleteImpact(privilege, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || privilege.id};
}
const key = 'privilege:' + privilege.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Role>('role', [...store.getState().roles.getMappingFor('privileges', privilege.id)]).filter(roleTemp => roleTemp.privileges?.includes(privilege.id)).forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
if (_role.status === 'D') return;
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.privileges = _role.privileges?.filter(id => id !== privilege.id) || [];

_work.set('role:' + _role.id, _role);
dispatch(Actions.RoleActions.saveRoleQueue(_role), 'role:' + _role.id);
});
const deleted = privilege.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.PrivilegeActions.removePrivilegeQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replacePrivilege(privilege: Privilege, replaceWith: Privilege, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = privilege.id;}
const _work = workingSet();
workingRows<Role>('role', [...store.getState().roles.getMappingFor('privileges', privilege.id)]).filter(roleTemp => roleTemp.privileges?.includes(privilege.id)).forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
if (_role.status === 'D') return;
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.privileges = _role.privileges?.map(id => (id === privilege.id) ? replaceWith.id : id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});



return privilege;
}
